import {useTranslation} from 'react-i18next';
import * as css from './PermissionBanner.css';
import Lock from '../../../assets/icons/Lock';

interface PermissionBannerProps {
    permissions: string[];
}

function PermissionBanner({permissions}: PermissionBannerProps) {
    const {t} = useTranslation('layout');
    
    if (!permissions || permissions.length === 0) {
        return null;
    }

    const permissionText = permissions.map(per => `{${t(per)}}`).join(' / ');

    return (
        <css.container>
            <Lock />
            <span>{t('permissionsDesc')} {permissionText}</span>
        </css.container>
    );
}

export default PermissionBanner;
